import http from '../http'

export default {
  switchAccount (org) {
    return http.post('/switch_account', org)
  }
}
